(function () {
  var config = window.consentTrackingConfig || {};
  var KLAVIYO_PUBLIC_KEY = config.klaviyoPublicKey;
  var klaviyoLoaded = false;
  var aliaLoaded = false;
  var tripleWhaleLoaded = false;

  function getCustomerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function shouldAllowMarketing() {
    var cp = getCustomerPrivacy();
    if (!cp) return false;

    var consent = cp.currentVisitorConsent();

    if (consent.marketing === 'no') return false;
    if (consent.marketing === 'yes') return true;

    return false;
  }

  function setMarketingAllowed(allowed) {
    window.__NW_consentMarketingAllowed = allowed;
  }

  function loadKlaviyo() {
    if (klaviyoLoaded || !KLAVIYO_PUBLIC_KEY) return;
    klaviyoLoaded = true;

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/' + KLAVIYO_PUBLIC_KEY + '/klaviyo.js';
    script.onload = function () {
      var email = config.customerEmail;
      if (email && window.klaviyo) {
        window.klaviyo.identify({ $email: email });
      }
    };
    document.head.appendChild(script);
  }

  function loadAlia() {
    var alia = config.alia;
    if (aliaLoaded || !alia || !alia.enabled) return;
    if (window.Shopify && window.Shopify.designMode) return;

    aliaLoaded = true;
    window.ALIA_SHOPIFY_EXTENSION_INFO = alia.extensionInfo;

    var script = document.createElement('script');
    script.async = true;
    script.src = alia.backendUrl + '/public/launcher.js?shop=' + encodeURIComponent(alia.shop);
    document.head.appendChild(script);
  }

  function enableTripleWhaleTracking() {
    if (typeof window.TriplePixel === 'function') {
      try {
        window.TriplePixel('trackingConsent', true);
      } catch (e) {}
    }
  }

  function loadTripleWhale() {
    var tripleWhale = config.tripleWhale;
    if (tripleWhaleLoaded || !tripleWhale || !tripleWhale.enabled) return;
    if (window.TriplePixelsn) {
      tripleWhaleLoaded = true;
      enableTripleWhaleTracking();
      return;
    }

    tripleWhaleLoaded = true;
    window.TriplePixelData = tripleWhale.pixelData;

    if (typeof window.__runTripleWhaleBootstrap === 'function') {
      window.__runTripleWhaleBootstrap();
    }

    var script = document.createElement('script');
    script.async = true;
    script.src = tripleWhale.mainJsUrl;
    script.onload = enableTripleWhaleTracking;
    document.head.appendChild(script);
  }

  function onConsentUpdate() {
    if (!shouldAllowMarketing()) {
      setMarketingAllowed(false);
      return;
    }

    setMarketingAllowed(true);
    loadKlaviyo();
    loadAlia();
    loadTripleWhale();
  }

  function initCustomerPrivacy() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      onConsentUpdate();
      document.addEventListener('visitorConsentCollected', onConsentUpdate);
    });
  }

  initCustomerPrivacy();
})();
